module.exports = __webpack_public_path__ + "img/title@2x.fd5c32af.png";